import { default as RecentlyViewed } from './recently-viewed'

export default RecentlyViewed
